import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"

import { BLOCK_SECTION_BORDER_RADIUS } from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/config/blockStyleConstants"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles(theme => ({
	container: {
		padding: theme.spacing(2),
		minHeight: theme.spacing(6),
		borderRadius: BLOCK_SECTION_BORDER_RADIUS,
		...ColorUtil.getBackgroundAndContrastColor(colors.blue[50])
	},
	shortcutNameText: {
		color: colors.gray[700],
		fontWeight: "bold",
		flex: 1,
		minWidth: 0,
		overflow: "hidden",
		whiteSpace: "nowrap",
		textOverflow: "ellipsis"
	},
	templateStatusChip: {
		cursor: "pointer",
		height: 20
	},
	title: {
		color: colors.blue[400]
	},
	listContainer: {
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[50]),
		overflowY: "scroll",
		height: "100%",
		maxHeight: "calc(100vh - 128px)",
		paddingTop: 0
	},
	listItem: {
		paddingBottom: theme.spacing(2),
		outline: "none"
	},
	templateName: {
		display: "flex",
		alignItems: "center",
		width: "100%",
		overflow: "hidden"
	}
}))

export default useStyles
